import { RefObject, useCallback, useEffect, useState } from 'react';

const events = ['mousedown', 'keydown', 'touchend', 'focus'];

export function useBodyEvents(
  orderSelectorRef: RefObject<HTMLDivElement>,
  onActivate: () => void = () => {},
  onDeactivate: () => void = () => {},
) {
  const [isEventsCapturingOn, setIsEventsCapturingOn] = useState<boolean>(false);

  let eventHandler = useCallback(
    (e: Event) => {
      if (!isEventsCapturingOn) {
        return;
      }
      const targetElement = e.target as HTMLElement;
      if (
        targetElement === orderSelectorRef.current ||
        orderSelectorRef.current?.contains(targetElement)
      ) {
        onActivate();
      } else {
        onDeactivate();
      }
    },
    [onActivate, onDeactivate, isEventsCapturingOn],
  );

  let attachEventHandlerToBody = useCallback(() => {
    events.forEach((evtName) =>
      document.body.addEventListener(evtName, eventHandler, { capture: true }),
    );
  }, [eventHandler]);
  let detachEventHandlerFromBody = useCallback(() => {
    events.forEach((evtName) =>
      document.body.removeEventListener(evtName, eventHandler, { capture: true }),
    );
  }, [eventHandler]);

  useEffect(() => {
    attachEventHandlerToBody();
    return () => {
      detachEventHandlerFromBody();
    };
  }, [attachEventHandlerToBody, detachEventHandlerFromBody]);

  return {
    startCapturing: () => setIsEventsCapturingOn(true),
    stopCapturing: () => setIsEventsCapturingOn(false),
  };
}
